import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useOptionsMode } from '../../context/OptionsModeContext';
import api, { isInAdminViewMode } from '../../lib/api';

const eventForPath = (pathname) => {
  if (pathname === '/options') return 'OPTIONS_DASHBOARD_VIEWED';
  if (pathname.startsWith('/options/positions')) return 'OPTIONS_OPEN_POSITIONS_VIEWED';
  if (pathname.startsWith('/options/history') || pathname.startsWith('/options/operations')) return 'OPTIONS_HISTORY_VIEWED';
  if (pathname.startsWith('/options/analytics')) return 'OPTIONS_ANALYTICS_VIEWED';
  if (pathname.startsWith('/options/performance')) return 'OPTIONS_PERFORMANCE_VIEWED';
  if (pathname.startsWith('/options/alerts')) return 'OPTIONS_ALERTS_VIEWED';
  return null;
};

export const OptionsProductUsageTracker = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { isDemoMode } = useOptionsMode();
  const lastNavigationRef = useRef(null);

  useEffect(() => {
    const eventName = eventForPath(location.pathname);
    const navigationKey = `${user?.id || ''}:${location.key}:${eventName || ''}`;
    if (!eventName || !user?.id || isDemoMode || isInAdminViewMode() || lastNavigationRef.current === navigationKey) return;

    lastNavigationRef.current = navigationKey;
    api.post('/options/product-events', { event_name: eventName }).catch(() => undefined);
  }, [isDemoMode, location.key, location.pathname, user?.id]);

  return null;
};